var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "details-view" }, [
    _c(
      "div",
      { staticClass: "main-contain" },
      [
        _c(
          "el-form",
          {
            staticClass: "section",
            attrs: {
              "label-position": "right",
              "label-width": "120px",
              "label-suffix": ":"
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "app-main-inner-row",
                staticStyle: { "flex-direction": "column" }
              },
              [
                _c("el-divider", { attrs: { "content-position": "left" } }, [
                  _vm._v(_vm._s(_vm.$t("SystemDocking.ExportSettings")))
                ]),
                _c(
                  "el-form-item",
                  { attrs: { label: "数据类型" } },
                  [
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.form.ar,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "ar", $$v)
                          },
                          expression: "form.ar"
                        }
                      },
                      [
                        _c("el-radio", { attrs: { label: 1 } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("SystemDocking.AccountsReceivableBills")
                            )
                          )
                        ]),
                        _c("el-radio", { attrs: { label: 0 } }, [
                          _vm._v(
                            _vm._s(_vm.$t("SystemDocking.AccountsPayableBills"))
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "app-main-inner-row",
                staticStyle: { "flex-direction": "column" }
              },
              [
                _c("el-divider", { attrs: { "content-position": "left" } }, [
                  _vm._v(_vm._s(_vm.$t("SystemDocking.ExportConditions")))
                ]),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SystemDocking.BusinessDate")
                            }
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "daterange",
                                "value-format": "yyyy-MM-dd"
                              },
                              model: {
                                value: _vm.form.businessDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "businessDate", $$v)
                                },
                                expression: "form.businessDate"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SystemDocking.OperationDate")
                            }
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "daterange",
                                "value-format": "yyyy-MM-dd"
                              },
                              model: {
                                value: _vm.form.customDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "customDate", $$v)
                                },
                                expression: "form.customDate"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SystemDocking.BillCreationDate")
                            }
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "daterange",
                                "value-format": "yyyy-MM-dd"
                              },
                              model: {
                                value: _vm.form.dateCreated,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "dateCreated", $$v)
                                },
                                expression: "form.dateCreated"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.form.ar
                                ? _vm.$t("SystemDocking.BillInvoicingDate")
                                : _vm.$t("SystemDocking.BillReceivingDate")
                            }
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "daterange",
                                "value-format": "yyyy-MM-dd"
                              },
                              model: {
                                value: _vm.form.invoiceDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "invoiceDate", $$v)
                                },
                                expression: "form.invoiceDate"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "SystemDocking.BillVoucherGenerationDate"
                              )
                            }
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "daterange",
                                "value-format": "yyyy-MM-dd"
                              },
                              model: {
                                value: _vm.form.voucherDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "voucherDate", $$v)
                                },
                                expression: "form.voucherDate"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("SystemDocking.BillNo") } },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.form.billingNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "billingNo", $$v)
                                },
                                expression: "form.billingNo"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SystemDocking.BusinessStatus")
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { multiple: "" },
                                model: {
                                  value: _vm.form.jobState,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "jobState", $$v)
                                  },
                                  expression: "form.jobState"
                                }
                              },
                              _vm._l(_vm.jobState, function(state) {
                                return _c("el-option", {
                                  key: state.code,
                                  attrs: {
                                    label: state.chineseName,
                                    value: state.code
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SystemDocking.BusinessType")
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { multiple: "" },
                                model: {
                                  value: _vm.form.lob,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "lob", $$v)
                                  },
                                  expression: "form.lob"
                                }
                              },
                              _vm._l(_vm.jobType, function(type) {
                                return _c("el-option", {
                                  key: type.code,
                                  attrs: {
                                    label: type.chineseName,
                                    value: type.code
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SystemDocking.OperatingBranch")
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Office,
                                multiple: "",
                                "default-multiple-value": _vm.form.branchId
                              },
                              on: {
                                parentCallBack: function(p) {
                                  return (_vm.form.branchId = [].concat(
                                    p.value
                                  ))
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 16 } },
                      [
                        _c("el-form-item", [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between"
                              }
                            },
                            [
                              _c("span", { staticClass: "orange" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SystemDocking.ReminderExportedAtOnce1000"
                                    )
                                  )
                                )
                              ]),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.handleExport }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SystemDocking.ConfirmExport")
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }